import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchAdmins, onSetSelectedAdmin, selectAdminState } from "../redux/slices/administratorSlice"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { ApiStatus } from "../types/api/status"
import { AdministratorAPI } from "../apis/AdministratorAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { Administrator } from "../types/slices/administratorType"

export const useAdministratorStore = () => {
    
    const dispatch = useDispatch()
    const { administrators, adminSelected, status } = useSelector(selectAdminState)

    // const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    // const idcompany = userData?.idcompany

    const getAdmins = async (data?:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await AdministratorAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false 
            }
            const { detail } = response.data
            dispatch(onFetchAdmins(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createAdmin = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await AdministratorAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateAdmin = async (id: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await AdministratorAPI.update(id, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteAdmin = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await AdministratorAPI.delete(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedAdmin = (data:Administrator) => {
        try {
            dispatch(onSetSelectedAdmin(data))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        administrators,
        adminSelected,
        status,
        getAdmins,
        createAdmin,
        updateAdmin,
        deleteAdmin,
        setSelectedAdmin
    }
}